/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Chat_Citations_All_SourcesInputs */



/**
* | output |
* | --- |
* | "{count} sources" |
*
* @param {Chat_Citations_All_SourcesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_citations_all_sources = /** @type {((inputs: Chat_Citations_All_SourcesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Citations_All_SourcesInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Quellen`)
	return /** @type {LocalizedString} */ (`${i?.count} sources`)
});